var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnDnsPrevent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-DNS-prevent",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(-0.373 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(-33 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(56.15 88.221)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(47.443 36.88)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(42.611 64.432)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(-22 -14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(81.357 79.38)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(89.932 47.762)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(62.533 16.227)",
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icn",
    transform: "translate(-1294.709 -48.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16606",
    "data-name": "Group 16606",
    transform: "translate(-2.861 -2.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12296",
    "data-name": "Path 12296",
    d: "M0,0A6.867,6.867,0,0,0,2.125,3.769c2.182,2.254,2.758,2.014,8,1.746,5.672-.292,13.6,3.054,14.4,4.872H.016S-.009.084,0,0Z",
    transform: "translate(1332.57 76.477) rotate(90)",
    fill: "#00aafc",
    opacity: 0.056
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12303",
    "data-name": "Path 12303",
    d: "M0,0S.142,1.127,2.125,2.469c2.182,1.477,2.758,1.319,8,1.144,5.672-.191,13.6,2,14.4,3.192H.016S-.009.055,0,0Z",
    transform: "translate(1327.376 76.477) rotate(90)",
    fill: "#00aafc",
    opacity: 0.056
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12412",
    "data-name": "Path 12412",
    d: "M1222.758,15.6h-6.264c-.206,0-.373-.352-.373-.786s.167-.786.373-.786h6.264c.206,0,.373.352.373.786S1222.964,15.6,1222.758,15.6Z",
    transform: "translate(136.463 54.11)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12314",
    "data-name": "Path 12314",
    d: "M1224.011,15.6h-7.446c-.245,0-.444-.352-.444-.786s.2-.786.444-.786h7.446c.245,0,.444.352.444.786S1224.256,15.6,1224.011,15.6Z",
    transform: "translate(89.481 82.58)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12411",
    "data-name": "Path 12411",
    d: "M1232.973,19.581h-6.9c-.206,0-.373-.352-.373-.787s.167-.785.373-.785h6.9c.206,0,.373.352.373.785S1233.179,19.581,1232.973,19.581Z",
    transform: "translate(131.745 53.371)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12315",
    "data-name": "Path 12315",
    d: "M1234.346,19.581h-8.2c-.245,0-.444-.352-.444-.787s.2-.785.444-.785h8.2c.245,0,.444.352.444.785S1234.591,19.581,1234.346,19.581Z",
    transform: "translate(85.682 81.84)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pc",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17129",
    "data-name": "Rectangle 17129",
    width: 36,
    height: 24,
    rx: 1,
    transform: "translate(1320.709 72.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1093",
    "data-name": "Line 1093",
    x2: 20,
    transform: "translate(1328.709 104.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1094",
    "data-name": "Line 1094",
    y2: 8,
    transform: "translate(1332.709 96.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1095",
    "data-name": "Line 1095",
    y2: 8,
    transform: "translate(1344.709 96.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17003",
    "data-name": "Group 17003",
    transform: "translate(-656.754 -1357.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12891",
    "data-name": "Path 12891",
    d: "M703.818,1386.678l-2.053-.208a3.694,3.694,0,0,1-1.436-.436l-2.128-1.288a1.484,1.484,0,0,0-1.433.015l-2.077,1.259a2.751,2.751,0,0,1-1.237.45l-2.271.207a1.456,1.456,0,0,0-1.3,1.7l1.522,9.334a3.626,3.626,0,0,0,2.121,2.665l2.79,1.384.035.016a2.908,2.908,0,0,0,2.291,0l.035-.016,2.79-1.384a3.634,3.634,0,0,0,2.124-2.681l1.518-9.31a1.456,1.456,0,0,0-1.293-1.711Zm-1.657,10.771a2.175,2.175,0,0,1-1.284,1.6l-.037.017-2.788,1.383a1.429,1.429,0,0,1-1.108,0l-2.788-1.383-.037-.017a2.168,2.168,0,0,1-1.281-1.587l-1.52-9.323s0-.013,0-.017l2.267-.207a4.206,4.206,0,0,0,1.836-.64l2.078-1.259,2.1,1.272a5.172,5.172,0,0,0,2.028.625l2.05.225Z",
    transform: "translate(0)",
    fill: "#49a9f5",
    stroke: "#49a9f5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17004",
    "data-name": "Group 17004",
    transform: "translate(35.043 30.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12894",
    "data-name": "Path 12894",
    d: "M0,0H10.543V10.543H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12895",
    "data-name": "Path 12895",
    d: "M5,9.2l2.2,2.2L11.589,7",
    transform: "translate(-2.804 -3.925)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDnsPrevent);
export default __webpack_public_path__ + "static/media/icn-DNS-prevent.59efe39de5c52d8b56652f70ae5d0c0b.svg";
export { ForwardRef as ReactComponent };